export const BasketIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2 text-amber-600" viewBox="0 0 100 100">
      <path d="M10 40 L90 40 L80 90 L20 90 Z" fill="currentColor" />
      <path d="M30 40 C30 20 70 20 70 40" stroke="currentColor" strokeWidth="8" fill="none" />
      <circle cx="35" cy="60" r="10" fill="#FF0000" />
      <circle cx="50" cy="55" r="8" fill="#00FF00" />
      <circle cx="65" cy="62" r="9" fill="#0000FF" />
    </svg>
  );